export default class FMeeting {
  constructor(
    id,
    kode1,
    description,
    statusActive,
    fdivisionBean,
    avatarImage,
    notes,
    online,
    price,
    meetTime,
    timeZone = "Asia/Jakarta",
    minutes,
    privated,
    linkZoom,
    showQrcode,
    itemDetil,
    enrolledNumber,
    showMateriRole=0,
    themeStyle=0,
    meetType= 1,

    maxParticipant=0,
    whatsAppPetugas="",
    regClose=false,

  ) {
    this.id = id;
    this.kode1 = kode1;
    this.description = description;
    this.statusActive = statusActive;
    this.fdivisionBean = fdivisionBean;
    this.avatarImage = avatarImage;
    this.notes = notes;
    this.online = online;
    this.price = price;
    this.meetTime = meetTime;
    this.timeZone = timeZone;
    this.minutes = minutes;
    this.privated = privated;
    this.linkZoom = linkZoom;
    this.itemDetil = itemDetil;
    this.showQrcode = showQrcode;
    this.enrolledNumber = enrolledNumber;
    this.showMateriRole = showMateriRole;
    this.themeStyle = themeStyle;
    this.meetType = meetType;

    this.maxParticipant = maxParticipant;
    this.whatsAppPetugas = whatsAppPetugas;
    this.regClose = regClose;

  }
}
